import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

function StatisticDesktop() {
  const history = useHistory();
  return <StatisticDesktopStyle></StatisticDesktopStyle>;
}
const StatisticDesktopStyle = styled.div`
  width: 100%;
  background-color: #313131;
  padding: 0 24px;
`;
export default StatisticDesktop;



// WEBPACK FOOTER //
// ./src/artist-ui/Statistic/StatisticDesktop.js